/**
 * SRE-3 — bulk-import carrier lock.
 *
 * In the bulk-import carrier step, a row's carrier is LOCKED (shown as
 * read-only text, no dropdown) when the rule that drove the row's
 * recommendation is NOT overridable. Overridable rules — and rows with no
 * rule attribution — keep the editable dropdown.
 *
 * Applies to both agent and merchant rules (origin-agnostic): the gate keys
 * purely on the matched rule's `is_overridable`.
 *
 * Lenient-while-unknown: if the rule isn't in the map yet (rules list still
 * loading, or the rule was deleted), we do NOT lock — the backend still
 * enforces a strict rule on submit, so the worst case is a transient editable
 * control, never a silently-locked one.
 *
 * @param recommendedRuleUid  the row's `recommended_rule_uid` (null when no rule drove it)
 * @param rulesOverridableByUid  map of rule uid -> is_overridable
 */
export function isImportRowCarrierLocked(
  recommendedRuleUid: string | null | undefined,
  rulesOverridableByUid: Map<string, boolean>,
): boolean {
  if (!recommendedRuleUid) return false;
  return rulesOverridableByUid.get(recommendedRuleUid) === false;
}
